// Catálogo ColoresLlamada: el campo `color` de un tipo de llamada (tiposllamada/Listado
// y los servicios de llamadas activas) es independiente de su área de atención, por lo
// que el color del badge nunca debe derivarse del área.
const COLOR_CLASSES = {
    1: 'parosView-table-color1', // Verde
    2: 'parosView-table-color2', // Rojo
    3: 'parosView-table-color3', // Amarillo
    4: 'parosView-table-color4', // Azul
};

export const CLASE_SIN_COLOR = 'parosView-table-areaS';

export const claseColorLlamada = (color) => COLOR_CLASSES[color] ?? null;

// El backend expone el color como entero, pero los botones ANDON manejan el
// nombre (`colorName` del DTO). Aquí se traduce al código que espera
// GET /tiposllamada/ListadoPorColor?color={n}.
const CODIGOS_POR_NOMBRE = {
    Verde: 1,
    Rojo: 2,
    Amarillo: 3,
    Azul: 4,
};

// Devuelve null ante un nombre desconocido: quien llama debe degradar al
// catálogo completo en vez de pedir un color inválido al servidor.
export const codigoColorLlamada = (colorName) => CODIGOS_POR_NOMBRE[colorName] ?? null;
